import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const fetchWorkOrders = async (token) => {
  const response = await fetch(`${API_URL}/work-orders`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente arbeidsordre.');
};

export const searchWorkOrders = async (query, token, limit = 10) => {
  const response = await fetch(`${API_URL}/work-orders/mobile-search?q=${encodeURIComponent(query)}&filter=all&limit=${limit}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  const data = await handleResponse(response, 'Kunne ikke søke etter ordre.');
  return data.orders || [];
};

export const addTeamToWorkOrder = async (workOrderId, teamId, token) => {
  const response = await fetch(`${API_URL}/work-orders/${workOrderId}/teams`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify({ teamId }),
  });
  return handleResponse(response, 'Kunne ikke tildele team.');
};

export const fetchWorkOrder = async (id, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente arbeidsordre.');
};

export const createWorkOrder = async (workOrderData, token) => {
  const response = await fetch(`${API_URL}/work-orders`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify(workOrderData),
  });
  return handleResponse(response, 'Kunne ikke opprette arbeidsordre.');
};

export const updateWorkOrder = async (id, workOrderData, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify(workOrderData),
  });
  return handleResponse(response, 'Kunne ikke oppdatere arbeidsordre.');
};

export const deleteWorkOrder = async (id, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke slette arbeidsordre.');
};

export const fetchWorkOrderComments = async (id, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}/comments`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente kommentarer.');
};

export const addWorkOrderComment = async (id, text, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}/comments`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify({ text }),
  });
  return handleResponse(response, 'Kunne ikke lagre kommentar.');
};

export const fetchWorkOrderEvents = async (id, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}/events`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente historikk.');
};

export const addWorkOrderEvent = async (id, eventData, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}/events`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify(eventData),
  });
  return handleResponse(response, 'Kunne ikke lagre hendelse.');
};

export const fetchWorkOrderParts = async (id, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}/parts`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente deler.');
};

export const addWorkOrderPart = async (id, partData, token) => {
  const response = await fetch(`${API_URL}/work-orders/${id}/parts`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify(partData),
  });
  return handleResponse(response, 'Kunne ikke opprette del.');
};

export const updateWorkOrderPart = async (partId, partData, token) => {
  const response = await fetch(`${API_URL}/work-orders/parts/${partId}`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify(partData),
  });
  return handleResponse(response, 'Kunne ikke oppdatere del.');
};

export const updatePartStorageLocation = async (partId, storageLocationId, token) => {
  const response = await fetch(`${API_URL}/work-orders/parts/${partId}/storage-location`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify({ storageLocationId }),
  });
  return handleResponse(response, 'Kunne ikke oppdatere lagerplass.');
};

export const deleteWorkOrderPart = async (partId, token) => {
  const response = await fetch(`${API_URL}/work-orders/parts/${partId}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke slette del.');
};

export const fetchPartHistory = async (partId, token) => {
  const response = await fetch(`${API_URL}/work-orders/parts/${partId}/history`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente del-historikk.');
};

export const fetchBatchPartsSummary = async (token) => {
  const response = await fetch(`${API_URL}/work-orders/parts-summary`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente deloversikt.');
};

export const searchParts = async (searchTerm, token) => {
  const response = await fetch(`${API_URL}/work-orders/parts-search?q=${encodeURIComponent(searchTerm)}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke søke etter deler.');
};

export const fetchPartStats = async (partName, token) => {
  const response = await fetch(`${API_URL}/work-orders/parts-stats/${encodeURIComponent(partName)}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente delstatistikk.');
};

export const checkDuplicateOrder = async (orderNumber, token) => {
  const response = await fetch(`${API_URL}/work-orders/check-duplicate/${encodeURIComponent(orderNumber)}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke sjekke duplikat.');
};
